export const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const MOBILE_REGEX = /^[0-9]{10}$/;

export const isValidEmail = (value) =>
  typeof value === "string" && EMAIL_REGEX.test(value.trim());

export const isValidMobile = (value) =>
  typeof value === "string" && MOBILE_REGEX.test(value.trim());

export const isEmailOrMobile = (value) =>
  isValidEmail(value) || isValidMobile(value);
